import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Smartphone, ShieldCheck } from "lucide-react";

export const PickupPass = ({ order }) => {
  const paidFirst = order.installments?.some((i) => i.number === 1 && i.status === "paid");
  if (!paidFirst || !order.pickup_code || ["delivered", "cancelled", "refunded"].includes(order.status)) return null;
  return (
    <section className="digital-pickup-pass rounded-2xl border border-primary/25 bg-primary/5 p-6 mb-6" data-testid="pickup-pass">
      <div className="flex items-center gap-2 text-primary text-xs uppercase tracking-widest"><Smartphone className="w-4 h-4" /> Passe de entrega digital</div>
      <div className="flex flex-col sm:flex-row items-center gap-6 mt-5">
        {order.pickup_qr_token && <div className="bg-white p-3 rounded-xl shrink-0" data-testid="pickup-qr">
          <QRCodeSVG value={`VOLTIX:${order.number}:${order.pickup_qr_token}`} size={180} level="M" marginSize={4} title="QR de validação da entrega VOLTIX" />
        </div>}
        <div className="min-w-0 text-center sm:text-left">
          <p className="text-sm text-muted-foreground">Sem câmara? O estafeta pode introduzir o código:</p>
          <p className="font-mono text-2xl font-bold tracking-[0.25em] text-primary mt-2" data-testid="pickup-code">{order.pickup_code}</p>
          <p className="text-sm mt-3" data-testid="pickup-instructions">Mostra este ecrã apenas quando o estafeta estiver contigo. Depois de validar, confirma a encomenda e autoriza o pagamento da 2.ª parcela. A leitura não faz qualquer cobrança.</p>
          <p className="text-xs text-muted-foreground mt-3 flex items-center justify-center sm:justify-start gap-1"><ShieldCheck className="w-4 h-4 shrink-0" /> Apenas digital · não disponível para impressão</p>
        </div>
      </div>
      {order.shipping_address.country === "AO" && <p className="text-xs text-muted-foreground mt-4" data-testid="pickup-sms-status">SMS indisponível — ativação do Twilio pendente. O código está disponível neste ecrã.</p>}
    </section>
  );
};
